import { render, staticRenderFns } from "./dataAnalysisDetailProject.vue?vue&type=template&id=85605adc&scoped=true&"
import script from "./dataAnalysisDetailProject.vue?vue&type=script&lang=js&"
export * from "./dataAnalysisDetailProject.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysisDetailProject.vue?vue&type=style&index=0&id=85605adc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85605adc",
  null
  
)

export default component.exports